

export const index = 0;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/_layout.svelte.js')).default;
export const imports = ["_app/immutable/nodes/0.D8HIUGBI.js","_app/immutable/chunks/scheduler.CgctGpYI.js","_app/immutable/chunks/index.Dzy1rpav.js"];
export const stylesheets = ["_app/immutable/assets/0.gkIQOIII.css"];
export const fonts = [];
